import { render } from "./NotasCreditoView.vue?vue&type=template&id=6ca3c231"
import script from "./NotasCreditoView.vue?vue&type=script&lang=js"
export * from "./NotasCreditoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__